import { useQuery } from '@tanstack/react-query';

import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { ASSIGNMENT_QUEUE_BASE_PATH } from '../../constants/assignmentQueueBasePath';
import { getAssignmentQueues } from '../../requests/getAssignmentQueues';

export const useAssignmentQueues = (documentType: string) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getAssignmentQueues>>
  >({
    queryKey: [ASSIGNMENT_QUEUE_BASE_PATH, documentType],
    queryFn: () => getAssignmentQueues(constructGet, documentType),
    enabled: Boolean(documentType),
    onError: () => handleError('Failed to load queues.'),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'assignmentQueues'),
    ...rest,
  };
};
